<template>
  <div v-if="assetData" class="horizontal-slider-card">
    <router-link :to="url" @click.prevent.stop="openUrl">
      <v-img
        type="horizontal"
        v-if="assetData"
        :src="assetData['screenshot_small']"
        :title="assetData.title"
        :alt="assetData.title"
      />
      <div class="progress" v-if="progress">
        <div
          class="progress-bar bg-danger"
          role="progressbar"
          :aria-valuenow="progressValue"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="{ width: progressValue + '%' }"
        ></div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { AssetStore } from "@/stores/assetStore";
import { GenresStore } from "@/stores/genresStore";
import LazyImage from "@/components/utils/LaziImage.vue";

export default {
  name: "HorizontalSliderCard",
  components: {},
  props: {
    asset: {
      type: String,
      default: null,
    },
    progress: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openUrl() {
      this.$router.push(this.url);
    },
  },
  computed: {
    ...mapState(AssetStore, ["getAssetData"]),
    ...mapState(GenresStore, ["getGenre"]),
    progressValue() {
      if (this.progress) {
        return (
          (parseInt(this.assetData.seconds) /
            parseInt(this.assetData.duration)) *
            100 || 0
        );
      } else {
        return 0;
      }
    },
    url() {
      let url = this.$t("movie_route", { slug: this.assetData.slug });
      if (this.assetData.type === "series") {
        url = this.$t("serie_route", { slug: this.assetData.slug });
      }
      return url;
    },
    assetData() {
      return this.getAssetData(this.asset);
    },
    metadata() {
      let m = [];
      if (this.assetData.year !== null) {
        m.push(this.assetData.year);
      }
      if (this.assetData.length !== null) {
        m.push(this.assetData.length);
      }

      let genres = this.assetData.genres.map((genre) => {
        return this.getGenre(genre);
      });
      m.push(genres.join(", "));
      // 2019 ‧ 2h 2m ‧ Thriller/Crime
      return m.join(" ‧ ");
    },
  },
};
</script>

<style lang="scss">
.horizontal-slider-card {
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  //&:hover{
  //    transform: scale(1.1);
  //    transition: all 0.1s ease-in-out;
  //}
  border-radius: 16px;
  overflow: hidden;
  margin: 1em 0 1em 1em;

  .progress {
    background: #ffffff42;
    width: 90%;
    height: 5px;
    position: relative;
    top: -1em;
    left: 5%;
  }
}
</style>
